import React from 'react';
import { Card } from 'flowbite-react';
import { HiUsers, HiHome, HiMail, HiEye, HiSearch, HiTrendingUp } from 'react-icons/hi';

export default function QuickStats({ stats }) {
  const cards = [
    {
      title: 'Пользователи',
      value: stats?.total_users || 0,
      icon: HiUsers,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
      change: '+12%',
      changeType: 'increase'
    },
    {
      title: 'Объекты',
      value: stats?.total_properties || 0,
      icon: HiHome,
      color: 'text-green-600',
      bgColor: 'bg-green-100',
      change: '+5%',
      changeType: 'increase'
    },
    {
      title: 'Просмотры',
      value: stats?.total_views || 0,
      icon: HiEye,
      color: 'text-purple-600',
      bgColor: 'bg-purple-100',
      change: '+23%',
      changeType: 'increase'
    },
    {
      title: 'Рассылки',
      value: stats?.total_broadcasts || 0,
      icon: HiMail,
      color: 'text-orange-600',
      bgColor: 'bg-orange-100',
      change: '0%',
      changeType: 'neutral'
    },
    {
      title: 'Поиски',
      value: stats?.total_searches || 0,
      icon: HiSearch,
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-100',
      change: '+18%',
      changeType: 'increase'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mb-6">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card key={index} className="relative overflow-hidden">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">{card.title}</p>
                <p className="text-2xl font-bold text-gray-900">
                  {card.value.toLocaleString('ru-RU')}
                </p>
                <div className="flex items-center mt-2">
                  {card.changeType === 'increase' && (
                    <HiTrendingUp className="w-4 h-4 text-green-500 mr-1" />
                  )}
                  <span className={`text-xs ${
                    card.changeType === 'increase' ? 'text-green-500' : 
                    card.changeType === 'decrease' ? 'text-red-500' : 
                    'text-gray-500'
                  }`}>
                    {card.change} за месяц
                  </span>
                </div>
              </div>
              <div className={`p-3 rounded-lg ${card.bgColor}`}>
                <Icon className={`w-6 h-6 ${card.color}`} />
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}